import React, { useEffect, useState } from "react";
import Topbar from "../components/Topbar";
import Sidebar from "../components/Sidebar";
import styles from "../assets/css/Dashboard.module.css";
import { FaWater, FaTint, FaInfoCircle, FaFileAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import DepartmentTopbar from "./SuperAdmin/components/DepartmentTopbar";
import DepartmentSidebar from "./SuperAdmin/components/DepertmentSidebar";

function WaterTank() {
  const navigate = useNavigate();
  const [watertankList, setwatertankList] = useState([]);
  const [departmentType, setDepartmentType] = useState("");

  useEffect(() => {
    setDepartmentType(localStorage.getItem("type"));
  }, []);
  useEffect(() => {
    const fetchwatertankData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}WaterTankList`,
          {
            method: "POST",
          }
        );
        const data = await response.json();
        if (data.code === 1) {
          setwatertankList(data?.service_list);
        }
      } catch (error) {
        console.error("Error fetching watertank data:", error);
      }
    };
    fetchwatertankData();
  }, []);

  const handleViewReport = (service_id, service_name) => {
    departmentType
      ? navigate(
          `/departmentDashboard/water-tank/${service_id}/${service_name}`
        )
      : navigate(`/water-tank/${service_id}/${service_name}`);
  };

  return (
    <>
      {departmentType === "Sanitary" ? <DepartmentTopbar /> : <Topbar />}
      <div className="d-flex">
        {departmentType === "Sanitary" ? <DepartmentSidebar /> : <Sidebar />}
        <div className={styles.dashboardContainer}>
          <div className={styles.dashboardContent}>
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h2
                className="mb-0"
                style={{
                  color: "#2c3e50",
                  fontWeight: "600",
                  fontSize: "1.8rem",
                }}
              >
                Water Tank Management
              </h2>
            </div>
            <div className="row g-4">
              {watertankList.map((item, index) => (
                <div key={index} className="col-md-6">
                  <div
                    className="card h-100"
                    style={{
                      borderRadius: "15px",
                      overflow: "hidden",
                      background: "linear-gradient(145deg, #ffffff, #f8f9fa)",
                    }}
                  >
                    <div className="card-body p-4">
                      <div className="d-flex align-items-center mb-4">
                        <div
                          className="icon-wrapper"
                          style={{
                            width: "60px",
                            height: "60px",
                            borderRadius: "12px",
                            background:
                              "linear-gradient(45deg, #2196F3, #1976D2)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: "15px",
                          }}
                        >
                          <div style={{ color: "white" }}>
                            <FaWater size={24} />
                          </div>
                        </div>
                        <div>
                          <h5
                            className="card-title mb-1"
                            style={{
                              color: "#2c3e50",
                              fontWeight: "600",
                            }}
                          >
                            {item.service_name}
                          </h5>
                        </div>
                      </div>

                      <div className="row g-3">
                        <div className="col-6">
                          <div
                            className="stat-card p-3 text-center"
                            style={{
                              background: "rgba(33, 150, 243, 0.1)",
                              borderRadius: "10px",
                            }}
                          >
                            <FaTint className="text-primary mb-2" />
                            <h6 className="mb-1">Total Tanks</h6>
                            <p className="mb-0 fw-bold">{item.total_tank}</p>
                          </div>
                        </div>
                        <div className="col-6">
                          <div
                            className="stat-card p-3 text-center"
                            style={{
                              background: "rgba(33, 150, 243, 0.1)",
                              borderRadius: "10px",
                            }}
                          >
                            <FaInfoCircle className="text-primary mb-2" />
                            <h6 className="mb-1">Service ID</h6>
                            <p className="mb-0 fw-bold">{item.service_id}</p>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex justify-content-end mt-4">
                        <button
                          className="btn btn-primary"
                          onClick={() =>
                            handleViewReport(
                              item?.service_id,
                              item?.service_name
                            )
                          }
                          style={{
                            background:
                              "linear-gradient(45deg, #2196F3, #1976D2)",
                            border: "none",
                            borderRadius: "8px",
                            padding: "8px 20px",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <FaFileAlt />
                          View Report
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default WaterTank;
